import { render, staticRenderFns } from "./HeroIdle.vue?vue&type=template&id=d5b838ac&scoped=true&"
import script from "./HeroIdle.vue?vue&type=script&lang=js&"
export * from "./HeroIdle.vue?vue&type=script&lang=js&"
import style0 from "./HeroIdle.vue?vue&type=style&index=0&id=d5b838ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b838ac",
  null
  
)

export default component.exports